FamilycardsImageLibrary.controller('addUserFormController', [ '$scope', function( $scope ) {

	$scope.addUserForm = [];
	$scope.addUserForm.subscription_end_date_input = '';

	$scope.setSelectValue = function($value) {
		$scope.addUserForm.userType = $value;
	}

	$scope.formatDate = function() {
		$scope.addUserForm.subscription_end_date_input = $scope.addUserForm.subscription_end_date.format('YYYY-MM-DD');
	}


}]);